
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/google-retail",
      function () {
        return require("private-next-pages/destinations/google-retail.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/google-retail"])
      });
    }
  